import React from "react";
import { use } from "react";

const ScrollSection = () => {
    return (
        <div id="section-1" style={styles.container}>
            <div style={styles.section}>
                <h1 style={styles.head}>Comprehensive IT Solutions</h1>
                <p style={{ userSelect: "none" }} className="text-start">
                    We provide top-notch IT services, from software development to cloud
                    solutions, ensuring businesses stay ahead in the digital era.
                </p>
                <h2 style={{ userSelect: "none" }} >Our Key Services</h2>
                <ul style={styles.list}>
                    <li>🌐 Web &amp; App Development – Custom websites, mobile apps, and enterprise solutions.</li>
                    <li>☁️ Cloud Computing – Scalable AWS, Azure, and Google Cloud solutions.</li>
                    <li>🔒 Cybersecurity – Protect your data with advanced security strategies.</li>
                    <li>⚙️ IT Consulting – Strategic planning for digital transformation.</li>
                    <li>📱 Mobile App Development – Native and cross-platform apps using React Native &amp; Flutter.</li>
                    <li>🖥️ Custom Software Development – Tailored business software and enterprise applications.</li>
                    <li>📊 Business Intelligence (BI) – Data analytics, dashboards, and performance tracking.</li>
                    <li>🎨 UI/UX Design – Engaging designs for websites and applications.</li>
                    <li>💾 Database Management – SQL, NoSQL, and cloud-based databases.</li>
                    <li>🔍 SEO &amp; Digital Marketing – Boost website rankings and lead generation.</li>
                </ul>
            </div>
        </div>
    );
};

const styles = {
    container: {
        width: "100%",
        position: "relative",
        overflow: "hidden"
    },
    section: {
        display: "flex",
        alignItems: "start",
        justifyContent: "center",
        flexDirection: "column",
        textAlign: "center",
        fontSize: "2rem",
        fontWeight: "bold",
        color: "white",
        mixBlendMode: "difference",
        transition: "background-color 2s ease, color 2s ease",
        padding: "40px",
        position: "relative",
        zIndex: 2
    },
    list: {
        textAlign: "left",
        fontSize: "1.5rem",
        fontWeight: "normal",
        lineHeight: "1.6",
        listStyle: "none",
        color: "white",
        mixBlendMode: "difference",
        userSelect: "none",
    },
    head: {
        fontSize: "3rem",
        marginBottom: "20px",
        userSelect: "none"

    }
};

export default ScrollSection;

